import { useState } from 'react'
import { Link } from 'react-router-dom'
import { X, MonitorDown } from 'lucide-react'
import { isElectron } from '@/lib/electron'
import { useFeatureFlag } from '@/platform/feature-flags/useFeatureFlag'

const STORAGE_KEY = 'footage_desktop_banner_dismissed'

function getPlatformDownloadPath() {
  const ua = navigator.userAgent.toLowerCase()
  if (ua.includes('mac') || ua.includes('darwin')) return '/download-for-mac'
  if (ua.includes('win')) return '/download-for-windows'
  return null
}

export function DesktopAppBanner() {
  const [dismissed, setDismissed] = useState(() => {
    try { return localStorage.getItem(STORAGE_KEY) === '1' } catch { return false }
  })

  const showBanner = useFeatureFlag('desktop_banner')

  if (isElectron() || dismissed || !showBanner) return null

  const downloadPath = getPlatformDownloadPath()
  if (!downloadPath) return null

  const dismiss = () => {
    setDismissed(true)
    try { localStorage.setItem(STORAGE_KEY, '1') } catch {}
  }

  return (
    <div className="relative flex items-center justify-center gap-3 px-4 py-2 bg-gradient-to-r from-sky-50 via-blue-50/80 to-sky-50 border-b border-sky-100 text-sm">
      <MonitorDown className="h-3.5 w-3.5 text-sky-600 shrink-0 hidden sm:block" />
      <p className="text-neutral-600">
        <span className="hidden sm:inline">Edit, organize, and create with your local media files. </span>
        <Link
          to={downloadPath}
          className="font-medium text-sky-600 hover:text-sky-700 transition-colors underline underline-offset-2 decoration-sky-300 hover:decoration-sky-400"
        >
          Get the desktop app &rarr;
        </Link>
      </p>
      <button
        onClick={dismiss}
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 rounded-md text-neutral-400 hover:text-neutral-600 hover:bg-sky-100/60 transition-colors"
        aria-label="Dismiss"
      >
        <X className="h-3.5 w-3.5" />
      </button>
    </div>
  )
}
